/* exported $ */
var $ = jQuery.noConflict();
